import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import * as React from 'react';

import { SearchBox } from '@/imports/ui/components/algolia/SearchBox';
import { useGlobalSearchContext } from '@/imports/ui/components/search/SearchProvider';

import { GlobalSearchModalFooter } from './components/GlobalSearchModalFooter';
import { GlobalSearchModalNoResults } from './components/GlobalSearchModalNoResults';
import { GlobalSearchModalResults } from './components/GlobalSearchModalResults';
import { OpenSearchResults } from './components/OpenSearchResults';

/** Above Webflow utilities portal (~10050) and typical Webflow nav (~9999). */
const WEBFLOW_OVERLAY_Z = 11000;
const WEBFLOW_CONTENT_Z = 11001;

export const GlobalSearchModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  /** When false, avoids body overflow lock (Webflow mobile nav). Default true. */
  blockScrollOnMount?: boolean;
  /**
   * Raise modal above the Webflow utilities portal (desktop + mobile).
   * Without this, Chakra's default z-index (~1400) sits under the icons.
   */
  elevateAboveWebflowUtilities?: boolean;
  /**
   * Mobile Webflow only: transparent outside-click layer (no gray scrim) so
   * the input stays usable over the open hamburger menu.
   */
  webflowMobileHybrid?: boolean;
}> = (props) => {
  const { searchMode } = useGlobalSearchContext();
  const elevate = props.elevateAboveWebflowUtilities === true;
  const mobileHybrid = props.webflowMobileHybrid === true;

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      size="xl"
      scrollBehavior="inside"
      blockScrollOnMount={
        props.blockScrollOnMount ?? (mobileHybrid ? false : true)
      }
      closeOnOverlayClick
    >
      {mobileHybrid ? (
        <ModalOverlay
          bg="transparent"
          zIndex={elevate ? WEBFLOW_OVERLAY_Z : undefined}
        />
      ) : (
        <ModalOverlay zIndex={elevate ? WEBFLOW_OVERLAY_Z : undefined} />
      )}
      <ModalContent
        borderRadius="xl"
        containerProps={
          elevate
            ? {
                zIndex: WEBFLOW_CONTENT_Z,
                pointerEvents: 'auto',
              }
            : undefined
        }
        zIndex={elevate ? WEBFLOW_CONTENT_Z : undefined}
        pointerEvents="auto"
        bg="white"
        shadow="lg"
      >
        <ModalHeader>
          <SearchBox placeholder="Search Community" />
        </ModalHeader>
        {searchMode === 'opensearch' ? (
          <OpenSearchResults />
        ) : (
          <GlobalSearchModalResults />
        )}
        <GlobalSearchModalNoResults />
        <GlobalSearchModalFooter onClose={props.onClose} />
      </ModalContent>
    </Modal>
  );
};
